// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1CTzX","Image":"Header_Image__UyLtT","Link":"Header_Link__16mg0"};